import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

const FIREBASE_APKEY = process.env.REACT_APP_FIREBASE_APKEY
const FIREBASE_AUTHDOMAIN = process.env.REACT_APP_FIREBASE_AUTHDOMAIN
const FIREBASE_DATABASEURL = process.env.REACT_APP_FIREBASE_DATABASEURL
const FIREBASE_PROJECTID = process.env.REACT_APP_FIREBASE_PROJECTID
const FIREBASE_STORAGEBUCKET = process.env.REACT_APP_FIREBASE_STORAGEBUCKET
const FIREBASE_MESSAGINGSENDERIDmessagingSenderId = process.env.REACT_APP_FIREBASE_MESSAGINGSENDERIDmessagingSenderId
const FIREBASE_APPID = process.env.REACT_APP_FIREBASE_APPID
const FIREBASE_MEASUREMENTID = process.env.REACT_APP_FIREBASE_MEASUREMENTID

const firebaseConfig = {
    apiKey:FIREBASE_APKEY,
    authDomain:FIREBASE_AUTHDOMAIN,
    databaseURL:FIREBASE_DATABASEURL,
    projectId: FIREBASE_PROJECTID,
    storageBucket:FIREBASE_STORAGEBUCKET,
    messagingSenderId:FIREBASE_MESSAGINGSENDERIDmessagingSenderId,
    appId:FIREBASE_APPID,
    measurementId:FIREBASE_MEASUREMENTID,
};

const app = initializeApp(firebaseConfig);

// App Check — blocks non-browser clients and bots from hitting Firebase directly.
// Set REACT_APP_RECAPTCHA_SITE_KEY in .env after enabling App Check in Firebase console.
if (process.env.REACT_APP_RECAPTCHA_SITE_KEY) {
  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(process.env.REACT_APP_RECAPTCHA_SITE_KEY),
    isTokenAutoRefreshEnabled: true,
  });
}

const db = getFirestore(app);
const auth = getAuth(app);
export { db, auth };
